import { AxiosRequestConfig } from 'axios';

import { State } from 'model/State';
import hamsClient from 'modules/hams';
import { selectHamsClientConfig } from 'modules/auth/selectors';

import { baseAccountApiUrl } from '../..';
import { getImpersonationHeader } from 'util/mac/helpers';

export const deleteFromHamsClient = async (
  remainingPath: string,
  state: State,
  params?: AxiosRequestConfig['params'],
  needImpersonationHeader?: boolean,
) => {
  try {
    const config = selectHamsClientConfig(state);
    const impersonationHeader = getImpersonationHeader(state);

    return (
      await hamsClient.delete(`${baseAccountApiUrl}${remainingPath}`, {
        ...config,
        headers: { ...config.headers, ...(needImpersonationHeader ? impersonationHeader : {}) },
        params,
      })
    ).data;
  } catch (error) {
    return Promise.reject(error);
  }
};
